/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";
import "./filtering.css";

import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../../services/AxiosInstance";
import { useDispatch } from "react-redux";
import { fetchmoduleData } from "../../../../store/reducers/module";
import { fetchsubmoduleData } from "../../../../store/reducers/submodule";
import { useSelector } from "react-redux";

export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <div>
      Search :{" "}
      <input
        type="search"
        className="ml-2 input-search form-control"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
        style={{ width: "20%" }}
      />
    </div>
  );
};

export const Levels = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchmoduleData());
    dispatch(fetchsubmoduleData());
  }, []);
  const { data: modules } = useSelector((state) => state.module);
  const { data: submodules } = useSelector((state) => state.submodule);
  const keys = [
    "module.module_name",
    "sub_module.sub_module_name",
    "level_name",
    "description",
  ];
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const onShow = () => setShow(true);
  const onHide = () => setShow(false);
  const [editshow, setEditShow] = useState(false);
  const onEditShow = () => setEditShow(true);
  const onEditHide = () => setEditShow(false);
  const [loader, setLoader] = useState(false);
  const [fieldvalue, setFieldValue] = useState({
    module_id: "",
    sub_module_id: "",
    level_name: "",
    description: "",
  });

  const COLUMNS = [
    ...keys.map((key) => ({
      Header:
        key === "module.module_name"
          ? "Module Name"
          : key === "sub_module.sub_module_name"
          ? "SubModule Name"
          : key.replace(/_/g, " "),
      Footer:
        key === "module.module_name"
          ? "Module Name"
          : key === "sub_module.sub_module_name"
          ? "SubModule Name"
          : key.replace(/_/g, " "),
      accessor: key,
      Filter: ColumnFilter,
    })),
    {
      Header: "Action",
      Footer: "Action",
      Cell: ({ row }) => {
        const DeleteLevel = (id) => {
          setLoader(true);
          try {
            axiosInstance
              .get(`admin/level/delete/${id}`)
              .then((response) => {
                if (response.data.status === true) {
                  getLevel();
                  toast.success(response.data.message);
                  setLoader(false);
                } else {
                  toast.error("SomeThing went Wrong");
                  setLoader(false);
                }
              })
              .catch((errors) => {
                toast.error("SomeThing went Wrong");
                setLoader(false);
              });
          } catch (error) {
            toast.error(error);
          }
        };
        return (
          <>
            <div className="d-flex gap-2">
              <button
                onClick={() => {
                  getLevelID(row.original.id);
                }}
                title="Edit"
                className={`btn btn-outline-success btn-sm rounded`}
              >
                <i className="fa fa-pen" />
              </button>
              <button
                onClick={() => {
                  DeleteLevel(row.original.id);
                }}
                title="Edit"
                className={`btn btn-outline-danger btn-sm rounded`}
              >
                <i className="fa fa-trash" />
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const [columns] = useState(COLUMNS);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;
  const { globalFilter, pageIndex } = state;

  const getLevel = () => {
    setLoader(true);

    axiosInstance
      .get("admin/level/view")
      .then(function (response) {
        console.log(response, "Getting Compaines");
        if (response?.data.status === true) {
          setData(response?.data.data);
          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };
  const getLevelID = (id) => {
    setLoader(true);
    axiosInstance
      .get(`admin/level/edit/${id}`)
      .then(function (response) {
        console.log(response);
        if (response?.data.status === true) {
          setFieldValue(response?.data?.data);
          setLoader(false);
          onEditShow();
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };
  console.log(fieldvalue)
  const addSubModule = () => {
    setLoader(true);
    var formdata = new FormData();
    for (const key in fieldvalue) {
      if (Object.hasOwnProperty.call(fieldvalue, key)) {
        formdata.append(key, fieldvalue[key]);
      }
    }
    axiosInstance
      .post(`admin/level/store`, formdata)
      .then((response) => {
        if (response.data.status) {
          getLevel();
          onHide();
          toast.success(response.data.message);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const updateSubModule = (id) => {
    setLoader(true);
    var formdata = new FormData();
    for (const key in fieldvalue) {
      if (Object.hasOwnProperty.call(fieldvalue, key)) {
        formdata.append(key, fieldvalue[key]);
      }
    }
    axiosInstance
      .post(`admin/level/update/${id}`, formdata)
      .then((response) => {
        if (response.data.status) {
          getLevel();
          onEditHide();
          toast.success(response.data.message);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  useEffect(() => {
    getLevel();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValue({ ...fieldvalue, [name]: value });
  };

  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <div className="card">
        <div>
          <div className="card-header">
            <h4 className="card-title float-left">Level</h4>
            <button className="btn btn-primary float-end" onClick={onShow}>
              Add Level
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table
              {...getTableProps()}
              id="table-to-export" // Add the id attribute
              className="table display"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {/* {column.canFilter ? column.render("Filter") : null} */}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {" "}
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between">
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>
              {""}
            </span>
            <span className="table-index">
              Go to page :{" "}
              <input
                type="number"
                className="ml-2"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const pageNumber = e.target.value
                    ? Number(e.target.value) - 1
                    : 0;
                  gotoPage(pageNumber);
                }}
              />
            </span>
          </div>
          <div className="text-center">
            <div className="filter-pagination  mt-3">
              <button
                className=" previous-button"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>

              <button
                className="previous-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Previous
              </button>
              <button
                className="next-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Next
              </button>
              <button
                className=" next-button"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Add Modal */}
      <Modal show={show} onHide={onHide} size="md">
        <Modal.Header closeButton>Add Level</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className={`mb-3 col-6`}>
                <h5 className="text-capitalize">Module Name</h5>
                <select
                  type={"text"}
                  name={"module_id"}
                  className="form-control"
                  onChange={handleInputChange}
                >
                  <option selected hidden>
                    Select Module Name.......
                  </option>
                  {modules?.map((e) => (
                    <option value={e?.id}>{e?.module_name}</option>
                  ))}
                </select>
              </div>
              <div className={`mb-3 col-6`}>
                <h5 className="text-capitalize">SubModule Name</h5>
                <select
                  type={"text"}
                  name={"sub_module_id"}
                  className="form-control"
                  onChange={handleInputChange}
                >
                  <option selected hidden>
                    Select Module Name.......
                  </option>

                  {submodules
                    .filter((s) => s.module_id === Number(fieldvalue.module_id))
                    .map((e) => (
                      <option value={e?.id}>{e?.sub_module_name}</option>
                    ))}
                </select>
              </div>
              <div className={`mb-3 col-12`}>
                <h5 className="text-capitalize">Level Name</h5>
                <input
                  type={"text"}
                  name={"level_name"}
                  className="form-control"
                  onChange={handleInputChange}
                />
              </div>
              <div className={`mb-3 col-12`}>
                <h5 className="text-capitalize">Description</h5>
                <textarea
                  name={"description"}
                  className="form-control"
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onHide}>
            Close
          </Button>
          <Button variant="success" onClick={addSubModule}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Add Modal Close */}
      {/* Update Modal Start */}
      <Modal show={editshow} onHide={onEditHide} size="md">
        <Modal.Header closeButton>SubModule Detail</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className={`mb-3 col-6`}>
                <h5 className="text-capitalize">Module Name</h5>
                <select
                  type={"text"}
                  name={"module_id"}
                  className="form-control"
                  onChange={handleInputChange}
                  defaultValue={fieldvalue.module_id}
                >
                  <option selected hidden>
                    Select Module Name.......
                  </option>
                  {modules?.map((e) => (
                    <option value={e?.id}>{e?.module_name}</option>
                  ))}
                </select>
              </div>
              <div className={`mb-3 col-6`}>
                <h5 className="text-capitalize">SubModule Name</h5>
                <select
                  type={"text"}
                  name={"sub_module_id"}
                  className="form-control"
                  onChange={handleInputChange}
                  defaultValue={fieldvalue.sub_module_id}
                >
                  <option selected hidden>
                    Select Module Name.......
                  </option>
                  {submodules
                    .filter((s) => s.module_id === Number(fieldvalue.module_id))
                    .map((e) => (
                      <option value={e?.id}>{e?.sub_module_name}</option>
                    ))}
                </select>
              </div>
              <div className={`mb-3 col-12`}>
                <h5 className="text-capitalize">Level Name</h5>
                <input
                  type={"text"}
                  name={"level_name"}
                  className="form-control"
                  defaultValue={fieldvalue.level_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className={`mb-3 col-12`}>
                <h5 className="text-capitalize">Description</h5>
                <textarea
                  name={"description"}
                  className="form-control"
                  defaultValue={fieldvalue.description}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onEditHide}>
            Close
          </Button>
          <Button
            variant="success"
            onClick={() => updateSubModule(fieldvalue.id)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Update Modal Close */}
    </>
  );
};
export default Levels;
